const PSPDFKit = (window as any).PSPDFKit as typeof import('@nutrient-sdk/viewer').default;

export default PSPDFKit;
